import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import dataANFB from '../../data/dataANFB.json';
import './Home.scss';
import logo from '../../assets/logo.png';
interface DataStructure {
  [categoria: string]: {
    [subcategoria: string]: string[];
  };
}

const Home: React.FC = () => {
  const navigate = useNavigate();
  const [selectedCategoria, setSelectedCategoria] = useState<string>('');
  const [selectedSubcategoria, setSelectedSubcategoria] = useState<string>('');
  const [selectedProducto, setSelectedProducto] = useState<string>('');

  const [categorias, setCategorias] = useState<string[]>([]);
  const [subcategorias, setSubcategorias] = useState<string[]>([]);
  const [productos, setProductos] = useState<string[]>([]);

  const data: DataStructure = dataANFB;

  useEffect(() => {
    setCategorias(Object.keys(data));
  }, [data]);

  useEffect(() => {
    if (selectedCategoria) {
      const subcats = Object.keys(data[selectedCategoria] || {});
      setSubcategorias(subcats);
      setSelectedSubcategoria('');
      setSelectedProducto('');
      setProductos([]);
    } else {
      setSubcategorias([]);
      setSelectedSubcategoria('');
      setSelectedProducto('');
      setProductos([]);
    }
  }, [selectedCategoria, data]);

  useEffect(() => {
    if (selectedCategoria && selectedSubcategoria) {
      const prods = data[selectedCategoria][selectedSubcategoria] || [];
      setProductos(prods);
      setSelectedProducto('');
    } else {
      setProductos([]);
      setSelectedProducto('');
    }
  }, [selectedSubcategoria, selectedCategoria, data]);

  const handleCategoriaChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedCategoria(e.target.value);
  };

  const handleSubcategoriaChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedSubcategoria(e.target.value);
  };

  const handleProductoChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedProducto(e.target.value);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Selección:', {
      categoria: selectedCategoria,
      subcategoria: selectedSubcategoria,
      producto: selectedProducto
    });
    navigate('/report', {
      state: {
        categoria: selectedCategoria,
        subcategoria: selectedSubcategoria,
        producto: selectedProducto
      }
    });
  };

  return (
    <div className="home">
      <img src={logo} alt="Logo" className="logo" />
      <h1>Selección de Producto</h1>
      <form onSubmit={handleSubmit} className="product-form">
        <div className="form-group">
          <label htmlFor="categoria">Categoría:</label>
          <select
            id="categoria"
            value={selectedCategoria}
            onChange={handleCategoriaChange}
            className="form-select"
          >
            <option value="">Selecciona una categoría</option>
            {categorias.map((categoria) => (
              <option key={categoria} value={categoria}>
                {categoria}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="subcategoria">Grupo:</label>
          <select
            id="subcategoria"
            value={selectedSubcategoria}
            onChange={handleSubcategoriaChange}
            className="form-select"
            disabled={!selectedCategoria}
          >
            <option value="">Selecciona un grupo</option>
            {subcategorias.map((subcategoria) => (
              <option key={subcategoria} value={subcategoria}>
                {subcategoria}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="producto">Producto:</label>
          <select
            id="producto"
            value={selectedProducto}
            onChange={handleProductoChange}
            className="form-select"
            disabled={!selectedSubcategoria}
          >
            <option value="">Selecciona un producto</option>
            {productos.map((producto) => (
              <option key={producto} value={producto}>
                {producto}
              </option>
            ))}
          </select>
        </div>

        <button
          type="submit"
          className="submit-btn"
          disabled={!selectedProducto}
        >
          Consultar
        </button>
      </form>

      {/* {selectedProducto && (
        <div className="selection-summary">
          <h3>Selección actual:</h3>
          <p>
            <strong>Categoría:</strong> {selectedCategoria}
          </p>
          <p>
            <strong>Grupo:</strong> {selectedSubcategoria}
          </p>
          <p>
            <strong>Producto:</strong> {selectedProducto}
          </p>
        </div>
      )} */}
    </div>
  );
};

export default Home;
